import { defineComponent as _defineComponent } from 'vue'
import tippy, { type Props } from 'tippy.js'
import 'tippy.js/dist/border.css'
import 'tippy.js/dist/tippy.css'
import { onMounted, onUnmounted, onUpdated, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
	options: {
		type: Object,
		default: () => ({}),
	},
	appendTo: {
		type: [Object, String, Function],
		default: undefined,
	},
},
  setup(__props) {

const props = __props;

const tooltip = ref()
const content = ref()
const tooltipInstance = ref()

// const slots = useSlots()



function destroyTooltip() {
	if (tooltipInstance.value) {
		tooltipInstance.value.destroy()
	}
}

function initTooltip() {
	destroyTooltip()
	tooltipInstance.value = tippy(tooltip.value?.parentNode, {
		content: content.value,
		theme: 'smartforest',
		arrow: true,
		allowHTML: true,
		...(props.appendTo ? { appendTo: props.appendTo as Props['appendTo'] } : {}),
		...props.options,
	})
}

onMounted(initTooltip)
onUpdated(initTooltip)
onUnmounted(destroyTooltip)

return { __sfc: true,tooltip, content, tooltipInstance, props, destroyTooltip, initTooltip }
}

})